export enum EnSignalRNotificationTypes {
  LockCreated = 100,
  LockReleased,

  ReportDesignerReportOpened = 200,
  ReportDesignerReportSaved,
  ReportDesignerError,
  ReportDesignerIsDirty,

  TableReservationCreated = 1000,
  TableReservationEdited,

  CashSystemOnline = 2000,
  CashSystemOffline,
  CashSystemDataFetched = 2100,
  CashSystemPossibleReportsFetched = 2110,
  CashSystemReportFetched,
  CashSystemRevenuesForDaysFetched = 2200,

  InvoiceCreated = 3000,

  PmsSystemOnline = 4000,
  PmsSystemOffline,
  PmsSystemDataFetched = 4100,
  PmsSystemRoomPlanDataFetched = 4110,
  PmsSystemRoomReservationDataFetched,
  PmsSystemRoomReservationInfoFetched,
  PmsSystemRoomPlanDataResetted,
  PmsSystemRoomReservationSearchResultsReceived,
  PmsSystemRoomReservationInfoFetchedBySourceId,
  PmsSystemRevenuesForDaysFetched = 4200,

  CloudBackupMultiFileDownloadReady = 5000,
  CloudBackupMultiFileDownloadError,
  CloudBackupSingleFileDownloadUrlReceived,
  CloudBackupClientOnline = 5100,
  CloudBackupClientOffline,
  CloudBackupClientLogFileReceived,

  CloudBackupUploadingFileStart = 5200,
  CloudBackupUploadingFileError,
  CloudBackupUploadingFileCompleted,

  AccountingMonthlyReportDownloadNoData = 6000,
  AccountingMonthlyReportDownloadProgress,
  AccountingMonthlyReportDownloadFailed,
  AccountingMonthlyReportDownloadReady,
}
